import { LOCATION_CHANGE } from "connected-react-router";
import { OFFRES, ROOT } from "../../../constants/routes";
import {
    ACCESS_DENIED,
    API_END,
    API_ERROR,
    API_START,
    CLEAR_DECONNEXION,
    GET_PROFESSIONS,
    GET_PROFESSION_BAREME,
    SET_PROFESSIONS,
    SET_PROFESSION_BAREME,
    TOKEN_EXPIRED,
    SET_AUTH,
    SEND_AUTH,
    SET_FAQS,
    GET_FAQS,
    SET_SIMULATION,
    SET_VERIFY_OTP,
    SEND_VERIFY_OTP,
    SEND_VERIFY_OTP_INSCRIPTION,
    SET_VERIFY_OTP_INSCRIPTION,
    SET_CLIENT,
    SET_DEMANDE_PRET,
    ADD_CLIENT,
    SEND_DEMANDE_PRET,
    VERIFY_OTP_PASSWORD,
    CHANGE_PASSWORD,
    SET_CHANGE_PASSWORD,
    SET_VERIFY_OTP_PASSWORD,
    SET_UPDATE_MAIL,
    SET_VERIFY_OTP_MAIL,
    SET_UPDATE_PHONE,
    SET_VERIFY_OTP_PHONE,
    UPDATE_MAIL,
    VERIFY_OTP_MAIL,
    UPDATE_PHONE,
    VERIFY_OTP_PHONE,
    SET_DONNEES_COMPTE,
    GET_DONNEES_COMPTE,
    CLEAR_VERIFY_OTP_MAIL,
    CLEAR_VERIFY_OTP_PASSWORD,
    CLEAR_VERIFY_OTP_PHONE,
    CLEAR_UPDATE_MAIL,
    CLEAR_UPDATE_PHONE,
    CLEAR_CHANGE_PASSWORD,
    SEND_SIMULATION,
    ADD_RECLAMATION,
    SET_ADD_RECLAMATION,
    CLEAR_ADD_RECLAMATION,
    GET_AGENCES,
    SET_AGENCES,
    FORGOT_PWD,
    SET_FORGOT_PWD,
    CLEAR_FORGOT_PWD,
    VERIFY_OTP_FORGOT_PWD,
    SET_VERIFY_OTP_FORGOT_PWD,
    CLEAR_VERIFY_OTP_FORGOT_PWD,
    RESET_PWD,
    SET_RESET_PWD,
    CLEAR_RESET_PWD,
    SET_SIM_RESULT,
    SET_DOCUMENTS,
    SET_UPLOAD_DOCUMENT_PIECE,
    UPLOAD_DOCUMENT_PIECE,
    GET_DOCUMENTS,
    SET_UPDATE_DOCUMENT_PIECE,
    UPDATE_DOCUMENT_PIECE,
    SET_PRET_CONNECTE,
    SET_MONTANT,
    SET_NATURE_CREDIT,
    SET_CREATE_SIMULATION,
    CREATE_SIMULATION,
    CLEAR_SIM_RESULT,
    CLEAR_CREATE_SIMULATION,
    SET_CONFIG_PASSWORD,
    CONFIG_PASSWORD,
    SET_SECTEURS_ACTIVITE,
    GET_SECTEURS_ACTIVITE,
    GET_DEMANDES,
    SET_DEMANDES,
    SET_SCORING,
    GET_SCORING,
    SET_DEMANDE_PRET_CONNECTE,
    SEND_DEMANDE_PRET_CONNECTE,
    CLEAR_SCORING,
    CLEAR_DEMANDE_PRET_CONNECTE,
    CLEAR_CONFIG_PASSWORD,
    SET_DETAILS_DEMANDE,
    GET_DETAILS_DEMANDE,
    GET_CLIENT_DETAILS,
    SET_CLIENT_DETAILS,
    SET_CREATE_SIMULATION_CONNECTE,
    CREATE_SIMULATION_CONNECTE,
    CLEAR_CREATE_SIMULATION_CONNECTE,
    CLEAR_PRET_CONNECTE,
    SET_SCORING_CONNECTE,
    GET_SCORING_CONNECTE,
    CLEAR_SCORING_CONNECTE,
    SET_DONNEES_PRO,
    CLEAR_DONNEES_PRO,
    RESEND_OTP, //resendOtp(id)
    SET_RESEND_OTP, //data_RESEND_OTP
    CLEAR_RESEND_OTP, //clearResendOtp
    SET_CHOOSE_AGENCE,
    CHOOSE_AGENCE,
    CLEAR_CHOOSE_AGENCE,
    DELETE_DOCUMENT_PIECE,
    SET_DELETE_DOCUMENT_PIECE,
    CLEAR_DELETE_DOCUMENT_PIECE,
    RESEND_OTP_MAIL,
    RESEND_OTP_SMS,
    SET_RESEND_OTP_MAIL,
    SET_RESEND_OTP_SMS,
    CLEAR_RESEND_OTP_MAIL,
    CLEAR_RESEND_OTP_SMS,
    SEND_SIMULATION_AUTO,
    SET_SIMULATION_AUTO,
    SET_AUTH_DGSN,
    SEND_AUTH_DGSN,
    CLEAR_AUTH_DGSN,
    SET_DETAILS_DGSN,
    GET_DETAILS_DGSN,
    CLEAR_DETAILS_DGSN,
    SET_AUTH_DGSN_CONNECTED,
    SEND_AUTH_DGSN_CONNECTED,
    CLEAR_AUTH_DGSN_CONNECTED,
    SET_SIGN_DIGITALE,
    SEND_SIGN_DIGITALE,
    CLEAR_SIGN_DIGITALE,
    SET_CHOOSE_SIGNATURE,
    CHOOSE_SIGNATURE,
    CLEAR_CHOOSE_SIGNATURE,
    SET_STATUT_SIGNATURE,
    GET_STATUT_SIGNATURE,
    CLEAR_STATUT_SIGNATURE,
    SET_OTP_MAIL,
    SET_VERIFY_MAIL,
    SEND_OTP_MAIL,
    SEND_VERIFY_MAIL,
    CLEAR_OTP_MAIL,
    CLEAR_VERIFY_MAIL,
    CLEAR_SIMULATION,
    CLEAR_CLIENT,
    CLEAR_DEMANDE_PRET,
    SET_DETAILS,
    SET_REMINDER,
    SEND_REMINDER,
    CLEAR_REMINDER,
    SET_SIGN_OTP,
    SIGN_OTP,
    CLEAR_SIGN_OTP,
    SET_LOGIN,
    SEND_LOGIN,
    CLEAR_LOGIN,
    SITUATION_CLIENT,
    SET_SITUATION_CLIENT,
    CLEAR_SITUATION_CLIENT,
    GET_DETAIL_DOSSIER,
    SET_DETAIL_DOSSIER,
    CLEAR_DETAIL_DOSSIER,
    VERIFIER_DGSN_DOSSIER,
    SET_VERIFIER_DGSN_DOSSIER,
    CLEAR_VERIFIER_DGSN_DOSSIER,
    SET_INSCRIPTION_DONNEES,
    CLEAR_INSCRIPTION_DONNEES,
    SEND_INSCRIPTION_DONNEES,
    SEND_INSCRIPTION_CONTACT,
    SET_INSCRIPTION_CONTACT,
    CLEAR_INSCRIPTION_CONTACT,
    CONFIG_PASSWORD_INSCRIPTION,
    SET_CONFIG_PASSWORD_INSCRIPTION,
    CLEAR_CONFIG_PASSWORD_INSCRIPTION,
    SET_OTP_CONTRACT,
    SET_VERIFY_OTP_CONTRACT,
    VERIFY_OTP_CONTRACT,
    SEND_OTP_CONTRACT,
    CLEAR_VERIFY_OTP_CONTRACT,
    CLEAR_OTP_CONTRACT,
    CREATE_PS,
    CLEAR_PS,
    SET_PS,
    SET_PS_CONNECTE,
    CREATE_PS_CONNECTE,
    CLEAR_PS_CONNECTE,
    SET_NEW_SIMULATION,
    CLEAR_NEW_SIMULATION,
    GET_NEW_SIMULATION,
    SET_UPDATE_SIMULATION,
    UPDATE_NEW_SIMULATION,
    CLEAR_UPDATE_SIMULATION,
    SET_BAREMES,
    GET_BAREMES,
    CLEAR_BAREMES,
    SET_PROMO,
    SET_SIMULATE_PROMO,
    SIMULATE_PROMO,
    CLEAR_SIMULATE_PROMO,
    SET_CREATE_PROMO,
    CREATE_PROMO,
    CLEAR_CREATE_PROMO,
    SEND_CHECK_PARTENAIRE,
    SET_CHECK_PARTENAIRE,
    CLEAR_CHECK_PARTENAIRE,
    SET_OTP_PARTENAIRE,
    SET_VERIFY_OTP_PARTENAIRE,
    VERIFY_OTP_PARTENAIRE,
    SEND_OTP_PARTENAIRE,
    CLEAR_OTP_PARTENAIRE,
    CLEAR_VERIFY_OTP_PARTENAIRE,
    SET_PARTENAIRE,
    CLEAR_PARTENAIRE,
    GET_OFFRES_DETAILS,
    SET_OFFRES_DETAILS,
    CLEAR_OFFRES_DETAILS,
    SET_OFFRE_PARAM,
    GET_LOGOUT,
    LOGIN_CIN,
    SET_LOGIN_CIN,
    CLEAR_LOGIN_CIN,
    VERIFY_OTP_LOGIN_CIN,
    SET_VERIFY_OTP_LOGIN_CIN,
    CLEAR_VERIFY_OTP_LOGIN_CIN,
    SET_DOSSIERS_LOUEUR,
    GET_DOSSIERS_LOUEUR,
    VERIFY_OTP_UPDATE_NUM,
    SET_VERIFY_OTP_UPDATE_NUM,
    CLEAR_VERIFY_OTP_UPDATE_NUM,
    DOUBLE_VERIFY_OTP_UPDATE_NUM,
    SET_DOUBLE_VERIFY_OTP_UPDATE_NUM,
    CLEAR_DOUBLE_VERIFY_OTP_UPDATE_NUM
} from "../../actions/api";

const initialState = {
    montant: null
};
const ApiReducer = (state = initialState, action) => {
    console.log("action type => ", action.type);
    switch (action.type) {
        // case SET_AUTH:
        case SET_LOGIN:
            if (
                action.payload?.success &&
                action.payload?.token &&
                action.payload?.profil
            ) {
                //localStorage.setItem("token", action.payload.token); max-age=${60 *60 *24}
                document.cookie = `session_token=${action.payload.token}; path=/; secure; samesite=strict; `;
            }
            return { ...state, data_AUTH: action.payload };
        case SET_PROFESSIONS:
            return {
                ...state,
                data_PROFESSIONS: action.payload
            };
        case SET_PROFESSION_BAREME:
            return {
                ...state,
                data_PROFESSION_BAREME: action.payload
            };
        case SET_SIM_RESULT:
            return {
                ...state,
                data_SIM_INPUTS: action.payload
            };
        case SET_PRET_CONNECTE:
            return {
                ...state,
                data_PRET_CONNECTE: action.payload
            };
        case SET_DONNEES_PRO:
            return {
                ...state,
                data_DONNEES_PRO: action.payload
            };
        case SET_SIMULATION:
            return {
                ...state,
                data_SIMULATION: action.payload
            };
        case SET_FAQS:
            return {
                ...state,
                data_FAQS: action.payload
            };
        case SET_VERIFY_OTP:
            return {
                ...state,
                data_VERIFY_OTP: action.payload
            };
        case SET_VERIFY_OTP_INSCRIPTION:
            return {
                ...state,
                data_VERIFY_OTP_INSCRIPTION: action.payload
            };
        case SET_CLIENT:
            return {
                ...state,
                data_SET_CLIENT: action.payload
            };
        case SET_INSCRIPTION_DONNEES:
            return {
                ...state,
                data_INSCRIPTION_DONNEES: action.payload
            };
        case SET_INSCRIPTION_CONTACT:
            return {
                ...state,
                data_INSCRIPTION_CONTACT: action.payload
            };
        case SET_DEMANDE_PRET:
            return {
                ...state,
                data_SET_DEMANDE_PRET: action.payload
            };
        case SET_CHANGE_PASSWORD:
            return {
                ...state,
                data_SET_CHANGE_PASSWORD: action.payload
            };
        case SET_VERIFY_OTP_PASSWORD:
            return {
                ...state,
                data_SET_VERIFY_OTP_PASSWORD: action.payload
            };
        case SET_UPDATE_MAIL:
            return {
                ...state,
                data_SET_UPDATE_MAIL: action.payload
            };
        case SET_VERIFY_OTP_MAIL:
            return {
                ...state,
                data_SET_VERIFY_OTP_MAIL: action.payload
            };
        case SET_UPDATE_PHONE:
            return {
                ...state,
                data_SET_UPDATE_PHONE: action.payload
            };
        case SET_VERIFY_OTP_PHONE:
            return {
                ...state,
                data_SET_VERIFY_OTP_PHONE: action.payload
            };
        case SET_DONNEES_COMPTE:
            return {
                ...state,
                data_SET_DONNEES_COMPTE: action.payload
            };
        case SET_ADD_RECLAMATION:
            return {
                ...state,
                data_SET_ADD_RECLAMATION: action.payload
            };
        case SET_AGENCES:
            return {
                ...state,
                data_SET_AGENCES: action.payload
            };

        case SET_FORGOT_PWD:
            return {
                ...state,
                data_SET_FORGOT_PWD: action.payload
            };
        case SET_VERIFY_OTP_FORGOT_PWD:
            return {
                ...state,
                data_SET_VERIFY_OTP_FORGOT_PWD: action.payload
            };
        case SET_RESET_PWD:
            return {
                ...state,
                data_SET_RESET_PWD: action.payload
            };
        case SET_UPLOAD_DOCUMENT_PIECE:
            return {
                ...state,
                data_SET_UPLOAD_DOCUMENT_PIECE: action.payload
            };
        case SET_DOCUMENTS:
            return {
                ...state,
                data_SET_DOCUMENTS: action.payload
            };
        case SET_UPDATE_DOCUMENT_PIECE:
            return {
                ...state,
                data_SET_UPDATE_DOCUMENT_PIECE: action.payload
            };
        case SET_CREATE_SIMULATION:
            return {
                ...state,
                data_SET_CREATE_SIMULATION: action.payload
            };
        case SET_CONFIG_PASSWORD:
            return {
                ...state,
                data_SET_CONFIG_PASSWORD: action.payload
            };
        case SET_CONFIG_PASSWORD_INSCRIPTION:
            return {
                ...state,
                data_SET_CONFIG_PASSWORD_INSCRIPTION: action.payload
            };
        case SET_SECTEURS_ACTIVITE:
            return {
                ...state,
                data_SET_SECTEURS_ACTIVITE: action.payload
            };
        case SET_MONTANT:
            return {
                ...state,
                data_SET_MONTANT: action.payload
            };
        case SET_NATURE_CREDIT:
            return {
                ...state,
                data_SET_NATURE_CREDIT: action.payload
            };
        case SET_DEMANDES:
            return {
                ...state,
                data_SET_DEMANDES: action.payload
            };
        case SET_SCORING:
            return {
                ...state,
                data_SET_SCORING: action.payload
            };
        case SET_DEMANDE_PRET_CONNECTE:
            return {
                ...state,
                data_SET_DEMANDE_PRET_CONNECTE: action.payload
            };
        case SET_DETAILS_DEMANDE:
            return {
                ...state,
                data_SET_DETAILS_DEMANDE: action.payload
            };
        case SET_CLIENT_DETAILS:
            return {
                ...state,
                data_SET_CLIENT_DETAILS: action.payload
            };
        case SET_CREATE_SIMULATION_CONNECTE:
            return {
                ...state,
                data_SET_CREATE_SIMULATION_CONNECTE: action.payload
            };
        case SET_RESEND_OTP:
            return {
                ...state,
                data_RESEND_OTP: action.payload
            };
        case SET_SCORING_CONNECTE:
            return {
                ...state,
                data_SET_SCORING_CONNECTE: action.payload
            };
        case SET_CHOOSE_AGENCE:
            return {
                ...state,
                data_SET_CHOOSE_AGENCE: action.payload
            };
        case SET_DELETE_DOCUMENT_PIECE:
            return {
                ...state,
                data_SET_DELETE_DOCUMENT_PIECE: action.payload
            };
        case SET_RESEND_OTP_MAIL:
            return {
                ...state,
                data_SET_RESEND_OTP_MAIL: action.payload
            };
        case SET_SIMULATION_AUTO:
            return {
                ...state,
                data_SET_SIMULATION_AUTO: action.payload
            };
        case SET_AUTH_DGSN:
            return {
                ...state,
                data_SET_AUTH_DGSN: action.payload
            };
        case SET_DETAILS_DGSN:
            return {
                ...state,
                data_SET_DETAILS_DGSN: action.payload
            };
        case SET_AUTH_DGSN_CONNECTED:
            return {
                ...state,
                data_SET_AUTH_DGSN_CONNECTED: action.payload
            };
        case SET_SIGN_DIGITALE:
            return {
                ...state,
                data_SET_SIGN_DIGITALE: action.payload
            };
        case SET_CHOOSE_SIGNATURE:
            return {
                ...state,
                data_SET_CHOOSE_SIGNATURE: action.payload
            };
        case SET_STATUT_SIGNATURE:
            return {
                ...state,
                data_SET_STATUT_SIGNATURE: action.payload
            };
        case SET_OTP_MAIL:
            return {
                ...state,
                data_SET_OTP_MAIL: action.payload
            };
        case SET_VERIFY_MAIL:
            return {
                ...state,
                data_SET_VERIFY_MAIL: action.payload
            };
        case SET_DETAILS:
            return {
                ...state,
                data_SET_DETAILS: action.payload
            };
        case SET_REMINDER:
            return {
                ...state,
                data_SET_REMINDER: action.payload
            };
        case SET_SIGN_OTP:
            return {
                ...state,
                data_SET_SIGN_OTP: action.payload
            };
        case SET_SITUATION_CLIENT:
            return {
                ...state,
                data_SET_SITUATION_CLIENT: action.payload
            };
        case SET_DETAIL_DOSSIER:
            return {
                ...state,
                data_SET_DETAIL_DOSSIER: action.payload
            };
        case SET_VERIFIER_DGSN_DOSSIER:
            return {
                ...state,
                data_SET_VERIFIER_DGSN_DOSSIER: action.payload
            };

        case SET_OTP_CONTRACT:
            return {
                ...state,
                data_SET_OTP_CONTRACT: action.payload
            };
        case SET_VERIFY_OTP_CONTRACT:
            return {
                ...state,
                data_SET_VERIFY_OTP_CONTRACT: action.payload
            };
        case SET_PS:
            return {
                ...state,
                data_SET_PS: action.payload
            };
        case SET_PS_CONNECTE:
            return {
                ...state,
                data_SET_PS_CONNECTE: action.payload
            };
        case SET_NEW_SIMULATION:
            return {
                ...state,
                data_SET_NEW_SIMULATION: action.payload
            };
        case SET_UPDATE_SIMULATION:
            return {
                ...state,
                data_SET_UPDATE_SIMULATION: action.payload
            };
        case SET_BAREMES:
            return {
                ...state,
                data_SET_BAREMES: action.payload
            };
        case SET_PROMO:
            return {
                ...state,
                data_SET_PROMO: action.payload
            };
        case SET_SIMULATE_PROMO:
            return {
                ...state,
                data_SET_SIMULATE_PROMO: action.payload
            };
        case SET_CREATE_PROMO:
            return {
                ...state,
                data_SET_CREATE_PROMO: action.payload
            };
        case SET_CHECK_PARTENAIRE:
            return {
                ...state,
                data_SET_CHECK_PARTENAIRE: action.payload
            };
        case SET_OTP_PARTENAIRE:
            return {
                ...state,
                data_SET_OTP_PARTENAIRE: action.payload
            };
        case SET_VERIFY_OTP_PARTENAIRE:
            return {
                ...state,
                data_SET_VERIFY_OTP_PARTENAIRE: action.payload
            };
        case SET_PARTENAIRE:
            return {
                ...state,
                data_SET_PARTENAIRE: action.payload
            };
        case SET_OFFRES_DETAILS:
            return {
                ...state,
                data_SET_OFFRES_DETAILS: action.payload
            };
        case SET_OFFRE_PARAM:
            return {
                ...state,
                data_SET_OFFRE_PARAM: action.payload
            };

        case SET_LOGIN_CIN:
            return {
                ...state,
                data_SET_LOGIN_CIN: action.payload
            };
        case SET_DOSSIERS_LOUEUR:
            return {
                ...state,
                data_SET_DOSSIERS_LOUEUR: action.payload
            };

        case SET_VERIFY_OTP_LOGIN_CIN:
            if (
                action.payload?.success &&
                action.payload?.token &&
                action.payload?.profil
            ) {
                document.cookie = `session_token=${action.payload.token}; path=/; secure; samesite=strict; `;
                localStorage.setItem("profil", action.payload?.profil);
            }
            return { ...state, data_SET_VERIFY_OTP_LOGIN_CIN: action.payload };

        case SET_VERIFY_OTP_UPDATE_NUM:
            return {
                ...state,
                data_SET_VERIFY_OTP_UPDATE_NUM: action.payload
            };
        case SET_DOUBLE_VERIFY_OTP_UPDATE_NUM:
            return {
                ...state,
                data_SET_DOUBLE_VERIFY_OTP_UPDATE_NUM: action.payload
            };
        case API_START:
            if (action.payload === SEND_AUTH) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_AUTH: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_PROFESSIONS) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_PREFESSIONS: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_FAQS) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_FAQS: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_SIMULATION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_SIMULATION: true
                    },
                    isError: false
                };
            }
            if (action.payload === ADD_RECLAMATION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_ADD_RECLAMATION: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_AGENCES) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_AGENCES: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_VERIFY_OTP) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_VERIFY_OTP: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_VERIFY_OTP_INSCRIPTION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_VERIFY_OTP_INSCRIPTION: true
                    },
                    isError: false
                };
            }
            if (action.payload === ADD_CLIENT) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_ADD_CLIENT: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_INSCRIPTION_DONNEES) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_INSCRIPTION_DONNEES: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_INSCRIPTION_CONTACT) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_INSCRIPTION_CONTACT: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_DEMANDE_PRET) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_DEMANDE_PRET: true
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_PASSWORD) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_PASSWORD: true
                    },
                    isError: false
                };
            }
            if (action.payload === CHANGE_PASSWORD) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CHANGE_PASSWORD: true
                    },
                    isError: false
                };
            }
            if (action.payload === UPDATE_MAIL) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_UPDATE_MAIL: true
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_MAIL) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_MAIL: true
                    },
                    isError: false
                };
            }
            if (action.payload === UPDATE_PHONE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_UPDATE_PHONE: true
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_PHONE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_PHONE: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DONNEES_COMPTE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_DONNEES_COMPTE: true
                    },
                    isError: false
                };
            }

            if (action.payload === FORGOT_PWD) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_FORGOT_PWD: true
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_FORGOT_PWD) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_FORGOT_PWD: true
                    },
                    isError: false
                };
            }
            if (action.payload === RESET_PWD) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_RESET_PWD: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DOCUMENTS) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_DOCUMENTS: true
                    },
                    isError: false
                };
            }
            if (action.payload === UPLOAD_DOCUMENT_PIECE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_UPLOAD_DOCUMENT_PIECE: true
                    },
                    isError: false
                };
            }
            if (action.payload === UPDATE_DOCUMENT_PIECE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_UPDATE_DOCUMENT_PIECE: true
                    },
                    isError: false
                };
            }
            if (action.payload === CREATE_SIMULATION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CREATE_SIMULATION: true
                    },
                    isError: false
                };
            }
            if (action.payload === CONFIG_PASSWORD) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CONFIG_PASSWORD: true
                    },
                    isError: false
                };
            }
            if (action.payload === CONFIG_PASSWORD_INSCRIPTION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CONFIG_PASSWORD_INSCRIPTION: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_SECTEURS_ACTIVITE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_SECTEURS_ACTIVITE: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DEMANDES) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_DEMANDES: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_SCORING) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_SCORING: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_DEMANDE_PRET_CONNECTE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_DEMANDE_PRET_CONNECTE: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DETAILS_DEMANDE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_DETAILS_DEMANDE: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_CLIENT_DETAILS) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_CLIENT_DETAILS: true
                    },
                    isError: false
                };
            }
            if (action.payload === CREATE_SIMULATION_CONNECTE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CREATE_SIMULATION_CONNECTE: true
                    },
                    isError: false
                };
            }
            if (action.payload === RESEND_OTP) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_RESEND_OTP: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_SCORING_CONNECTE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_SCORING_CONNECTE: true
                    },
                    isError: false
                };
            }
            if (action.payload === CHOOSE_AGENCE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CHOOSE_AGENCE: true
                    },
                    isError: false
                };
            }
            if (action.payload === DELETE_DOCUMENT_PIECE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_DELETE_DOCUMENT_PIECE: true
                    },
                    isError: false
                };
            }
            if (action.payload === RESEND_OTP_MAIL) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_RESEND_OTP_MAIL: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_SIMULATION_AUTO) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_SIMULATION_AUTO: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_AUTH_DGSN) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_AUTH_DGSN: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DETAILS_DGSN) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_DETAILS_DGSN: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_AUTH_DGSN_CONNECTED) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_AUTH_DGSN_CONNECTED: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_SIGN_DIGITALE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_SIGN_DIGITALE: true
                    },
                    isError: false
                };
            }
            if (action.payload === CHOOSE_SIGNATURE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CHOOSE_SIGNATURE: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_STATUT_SIGNATURE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_STATUT_SIGNATURE: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_OTP_MAIL) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_OTP_MAIL: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_VERIFY_MAIL) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_VERIFY_MAIL: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_REMINDER) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_REMINDER: true
                    },
                    isError: false
                };
            }
            if (action.payload === SIGN_OTP) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SIGN_OTP: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_LOGIN) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_LOGIN: true
                    },
                    isError: false
                };
            }
            if (action.payload === SITUATION_CLIENT) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_OTP_CONTRACT: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_OTP_CONTRACT) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SITUATION_CLIENT: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DETAIL_DOSSIER) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_DETAIL_DOSSIER: true
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFIER_DGSN_DOSSIER) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFIER_DGSN_DOSSIER: true
                    },
                    isError: false
                };
            }
            if (action.payload === CREATE_PS) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CREATE_PS: true
                    },
                    isError: false
                };
            }
            if (action.payload === CREATE_PS_CONNECTE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CREATE_PS_CONNECTE: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_NEW_SIMULATION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_NEW_SIMULATION: true
                    },
                    isError: false
                };
            }
            if (action.payload === UPDATE_NEW_SIMULATION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_UPDATE_NEW_SIMULATION: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_BAREMES) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_BAREMES: true
                    },
                    isError: false
                };
            }
            if (action.payload === SIMULATE_PROMO) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SIMULATE_PROMO: true
                    },
                    isError: false
                };
            }
            if (action.payload === CREATE_PROMO) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CREATE_PROMO: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_CHECK_PARTENAIRE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_CHECK_PARTENAIRE: true
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_OTP_PARTENAIRE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_OTP_PARTENAIRE: true
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_PARTENAIRE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_PARTENAIRE: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_OFFRES_DETAILS) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_OFFRES_DETAILS: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_LOGOUT) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_LOGOUT: true
                    },
                    isError: false
                };
            }
            if (action.payload === LOGIN_CIN) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_LOGIN_CIN: true
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_LOGIN_CIN) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_LOGIN_CIN: true
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DOSSIERS_LOUEUR) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_DOSSIERS_LOUEUR: true
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_UPDATE_NUM) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_UPDATE_NUM: true
                    },
                    isError: false
                };
            }
            if (action.payload === DOUBLE_VERIFY_OTP_UPDATE_NUM) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_DOUBLE_VERIFY_OTP_UPDATE_NUM: true
                    },
                    isError: false
                };
            }
            return state;
        case API_END:
            if (action.payload === SEND_AUTH) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_AUTH: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_PROFESSIONS) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_PREFESSIONS: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_SIMULATION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_SIMULATION: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_FAQS) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_FAQS: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_PROFESSION_BAREME) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_PREFESSION_BAREME: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_VERIFY_OTP) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_VERIFY_OTP: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_VERIFY_OTP_INSCRIPTION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_VERIFY_OTP_INSCRIPTION: false
                    },
                    isError: false
                };
            }
            if (action.payload === ADD_CLIENT) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_ADD_CLIENT: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_INSCRIPTION_DONNEES) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_INSCRIPTION_DONNEES: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_INSCRIPTION_CONTACT) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_INSCRIPTION_CONTACT: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_DEMANDE_PRET) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_DEMANDE_PRET: false
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_PASSWORD) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_PASSWORD: false
                    },
                    isError: false
                };
            }
            if (action.payload === CHANGE_PASSWORD) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CHANGE_PASSWORD: false
                    },
                    isError: false
                };
            }
            if (action.payload === UPDATE_MAIL) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_UPDATE_MAIL: false
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_MAIL) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_MAIL: false
                    },
                    isError: false
                };
            }
            if (action.payload === UPDATE_PHONE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_UPDATE_PHONE: false
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_PHONE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_PHONE: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DONNEES_COMPTE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_DONNEES_COMPTE: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_PROFESSION_BAREME) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_PREFESSION_BAREME: false
                    },
                    isError: false
                };
            }
            if (action.payload === ADD_RECLAMATION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_ADD_RECLAMATION: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_AGENCES) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_AGENCES: false
                    },
                    isError: false
                };
            }
            if (action.payload === FORGOT_PWD) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_FORGOT_PWD: false
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_FORGOT_PWD) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_FORGOT_PWD: false
                    },
                    isError: false
                };
            }
            if (action.payload === RESET_PWD) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_RESET_PWD: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DOCUMENTS) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_DOCUMENTS: false
                    },
                    isError: false
                };
            }
            if (action.payload === UPLOAD_DOCUMENT_PIECE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_UPLOAD_DOCUMENT_PIECE: false
                    },
                    isError: false
                };
            }
            if (action.payload === UPDATE_DOCUMENT_PIECE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_UPDATE_DOCUMENT_PIECE: false
                    },
                    isError: false
                };
            }
            if (action.payload === CREATE_SIMULATION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CREATE_SIMULATION: false
                    },
                    isError: false
                };
            }
            if (action.payload === CONFIG_PASSWORD) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CONFIG_PASSWORD: false
                    },
                    isError: false
                };
            }
            if (action.payload === CONFIG_PASSWORD_INSCRIPTION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CONFIG_PASSWORD_INSCRIPTION: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_SECTEURS_ACTIVITE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_SECTEURS_ACTIVITE: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DEMANDES) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_DEMANDES: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_SCORING) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_SCORING: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_DEMANDE_PRET_CONNECTE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_DEMANDE_PRET_CONNECTE: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DETAILS_DEMANDE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_DETAILS_DEMANDE: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_CLIENT_DETAILS) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_CLIENT_DETAILS: false
                    },
                    isError: false
                };
            }
            if (action.payload === CREATE_SIMULATION_CONNECTE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CREATE_SIMULATION_CONNECTE: false
                    },
                    isError: false
                };
            }
            if (action.payload === RESEND_OTP) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_RESEND_OTP: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_SCORING_CONNECTE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_SCORING_CONNECTE: false
                    },
                    isError: false
                };
            }
            if (action.payload === CHOOSE_AGENCE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CHOOSE_AGENCE: false
                    },
                    isError: false
                };
            }
            if (action.payload === DELETE_DOCUMENT_PIECE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_DELETE_DOCUMENT_PIECE: false
                    },
                    isError: false
                };
            }
            if (action.payload === RESEND_OTP_MAIL) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_RESEND_OTP_MAIL: false
                    },
                    isError: false
                };
            }
            if (action.payload === RESEND_OTP_SMS) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_RESEND_OTP_SMS: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_SIMULATION_AUTO) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_SIMULATION_AUTO: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_AUTH_DGSN) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_AUTH_DGSN: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DETAILS_DGSN) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_DETAILS_DGSN: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_AUTH_DGSN_CONNECTED) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_AUTH_DGSN_CONNECTED: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_SIGN_DIGITALE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_SIGN_DIGITALE: false
                    },
                    isError: false
                };
            }
            if (action.payload === CHOOSE_SIGNATURE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CHOOSE_SIGNATURE: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_STATUT_SIGNATURE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_STATUT_SIGNATURE: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_OTP_MAIL) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_OTP_MAIL: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_VERIFY_MAIL) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_VERIFY_MAIL: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_REMINDER) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_REMINDER: false
                    },
                    isError: false
                };
            }
            if (action.payload === SIGN_OTP) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SIGN_OTP: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_LOGIN) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_LOGIN: false
                    },
                    isError: false
                };
            }
            if (action.payload === SITUATION_CLIENT) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SITUATION_CLIENT: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_OTP_CONTRACT) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_OTP_CONTRACT: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DETAIL_DOSSIER) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_CONTRACT: false
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFIER_DGSN_DOSSIER) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFIER_DGSN_DOSSIER: false
                    },
                    isError: false
                };
            }
            if (action.payload === CREATE_PS) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CREATE_PS: false
                    },
                    isError: false
                };
            }
            if (action.payload === CREATE_PS_CONNECTE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CREATE_PS_CONNECTE: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_NEW_SIMULATION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_NEW_SIMULATION: false
                    },
                    isError: false
                };
            }
            if (action.payload === UPDATE_NEW_SIMULATION) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_UPDATE_NEW_SIMULATION: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_BAREMES) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_BAREMES: false
                    },
                    isError: false
                };
            }
            if (action.payload === SIMULATE_PROMO) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SIMULATE_PROMO: false
                    },
                    isError: false
                };
            }
            if (action.payload === CREATE_PROMO) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_CREATE_PROMO: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_CHECK_PARTENAIRE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_CHECK_PARTENAIRE: false
                    },
                    isError: false
                };
            }
            if (action.payload === SEND_OTP_PARTENAIRE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_SEND_OTP_PARTENAIRE: false
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_PARTENAIRE) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_PARTENAIRE: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_OFFRES_DETAILS) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_OFFRES_DETAILS: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_LOGOUT) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_LOGOUT: false
                    },
                    isError: false
                };
            }
            if (action.payload === LOGIN_CIN) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_LOGIN_CIN: false
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_LOGIN_CIN) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_LOGIN_CIN: false
                    },
                    isError: false
                };
            }
            if (action.payload === GET_DOSSIERS_LOUEUR) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_GET_DOSSIERS_LOUEUR: false
                    },
                    isError: false
                };
            }
            if (action.payload === VERIFY_OTP_UPDATE_NUM) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_VERIFY_OTP_UPDATE_NUM: false
                    },
                    isError: false
                };
            }
            if (action.payload === DOUBLE_VERIFY_OTP_UPDATE_NUM) {
                return {
                    ...state,
                    isLoadingData: {
                        ...state.isLoadingData,
                        isLoadingData_DOUBLE_VERIFY_OTP_UPDATE_NUM: false
                    },
                    isError: false
                };
            }
            return state;
        case CLEAR_DECONNEXION:
            document.cookie =
                "session_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            document.cookie =
                "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            //console.log("initial", initialState);
            //Cookies.expire("authToken");
            return initialState;
        case CLEAR_ADD_RECLAMATION:
            return {
                ...state,
                data_SET_ADD_RECLAMATION: null
            };
        case TOKEN_EXPIRED:
            localStorage.clear();
            document.cookie =
                "session_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            return initialState;
        case CLEAR_VERIFY_OTP_MAIL:
            return {
                ...state,
                data_SET_VERIFY_OTP_MAIL: null
            };
        case CLEAR_VERIFY_OTP_PHONE:
            return {
                ...state,
                data_SET_VERIFY_OTP_PHONE: null
            };
        case CLEAR_VERIFY_OTP_PASSWORD:
            return {
                ...state,
                data_SET_VERIFY_OTP_PASSWORD: null
            };
        case CLEAR_UPDATE_MAIL:
            return {
                ...state,
                data_SET_UPDATE_MAIL: null
            };
        case CLEAR_UPDATE_PHONE:
            return {
                ...state,
                data_SET_UPDATE_PHONE: null
            };
        case CLEAR_CHANGE_PASSWORD:
            return {
                ...state,
                data_SET_CHANGE_PASSWORD: null
            };

        case CLEAR_FORGOT_PWD:
            return {
                ...state,
                data_SET_FORGOT_PWD: null
            };
        case CLEAR_VERIFY_OTP_FORGOT_PWD:
            return {
                ...state,
                data_SET_VERIFY_OTP_FORGOT_PWD: null
            };
        case CLEAR_RESET_PWD:
            return {
                ...state,
                data_SET_RESET_PWD: null
            };
        case CLEAR_SIM_RESULT:
            return {
                ...state,
                data_SIM_INPUTS: null
            };
        case CLEAR_CREATE_SIMULATION:
            return {
                ...state,
                data_SET_CREATE_SIMULATION: null
            };
        case CLEAR_CREATE_SIMULATION_CONNECTE:
            return {
                ...state,
                data_SET_CREATE_SIMULATION_CONNECTE: null
            };
        case CLEAR_SCORING:
            return {
                ...state,
                data_SET_SCORING: null
            };
        case CLEAR_DEMANDE_PRET_CONNECTE:
            return {
                ...state,
                data_SET_DEMANDE_PRET_CONNECTE: null
            };
        case CLEAR_CONFIG_PASSWORD:
            return {
                ...state,
                data_SET_CONFIG_PASSWORD: null
            };
        case CLEAR_CONFIG_PASSWORD_INSCRIPTION:
            return {
                ...state,
                data_SET_CONFIG_PASSWORD_INSCRIPTION: null
            };
        case CLEAR_PRET_CONNECTE:
            return {
                ...state,
                data_PRET_CONNECTE: null
            };

        case CLEAR_RESEND_OTP:
            return {
                ...state,
                data_RESEND_OTP: null
            };
        case CLEAR_DONNEES_PRO:
            return {
                ...state,
                data_DONNEES_PRO: null
            };
        case CLEAR_SCORING_CONNECTE:
            return {
                ...state,
                data_SET_SCORING_CONNECTE: null
            };
        case CLEAR_CHOOSE_AGENCE:
            return {
                ...state,
                data_SET_CHOOSE_AGENCE: null
            };
        case CLEAR_DELETE_DOCUMENT_PIECE:
            return {
                ...state,
                data_SET_DELETE_DOCUMENT_PIECE: null
            };
        case CLEAR_RESEND_OTP_MAIL:
            return {
                ...state,
                data_SET_RESEND_OTP_MAIL: null
            };
        case CLEAR_RESEND_OTP_SMS:
            return {
                ...state,
                data_SET_RESEND_OTP_SMS: null
            };
        case CLEAR_AUTH_DGSN:
            return {
                ...state,
                data_SET_AUTH_DGSN: null
            };
        case CLEAR_DETAILS_DGSN:
            return {
                ...state,
                data_SET_DETAILS_DGSN: null
            };
        case CLEAR_AUTH_DGSN_CONNECTED:
            return {
                ...state,
                data_SET_AUTH_DGSN_CONNECTED: null
            };
        case CLEAR_SIGN_DIGITALE:
            return {
                ...state,
                data_SET_SIGN_DIGITALE: null
            };
        case CLEAR_CHOOSE_SIGNATURE:
            return {
                ...state,
                data_SET_CHOOSE_SIGNATURE: null
            };
        case CLEAR_STATUT_SIGNATURE:
            return {
                ...state,
                data_SET_STATUT_SIGNATURE: null
            };
        case CLEAR_OTP_MAIL:
            return {
                ...state,
                data_SET_OTP_MAIL: null
            };
        case CLEAR_VERIFY_MAIL:
            return {
                ...state,
                data_SET_VERIFY_MAIL: null
            };
        case CLEAR_SIMULATION:
            return {
                ...state,
                data_SIMULATION: null
            };
        case CLEAR_CLIENT:
            return {
                ...state,
                data_SET_CLIENT: null
            };
        case CLEAR_INSCRIPTION_DONNEES:
            return {
                ...state,
                data_INSCRIPTION_DONNEES: null
            };
        case CLEAR_INSCRIPTION_CONTACT:
            return {
                ...state,
                data_INSCRIPTION_CONTACT: null
            };
        case CLEAR_DEMANDE_PRET:
            return {
                ...state,
                data_SET_DEMANDE_PRET: null
            };
        case CLEAR_REMINDER:
            return {
                ...state,
                data_SET_REMINDER: null
            };
        case CLEAR_SIGN_OTP:
            return {
                ...state,
                data_SET_SIGN_OTP: null
            };
        case CLEAR_LOGIN:
            return {
                ...state,
                data_AUTH: null
            };
        case CLEAR_SITUATION_CLIENT:
            return {
                ...state,
                data_SET_SITUATION_CLIENT: null
            };
        case CLEAR_DETAIL_DOSSIER:
            return {
                ...state,
                data_SET_DETAIL_DOSSIER: null
            };
        case CLEAR_VERIFIER_DGSN_DOSSIER:
            return {
                ...state,
                data_SET_VERIFIER_DGSN_DOSSIER: null
            };
        case CLEAR_OTP_CONTRACT:
            return {
                ...state,
                data_SET_OTP_CONTRACT: null
            };
        case CLEAR_VERIFY_OTP_CONTRACT:
            return {
                ...state,
                data_SET_VERIFY_OTP_CONTRACT: null
            };
        case CLEAR_PS:
            return {
                ...state,
                data_SET_PS: null
            };
        case CLEAR_PS_CONNECTE:
            return {
                ...state,
                data_SET_PS_CONNECTE: null
            };
        case CLEAR_NEW_SIMULATION:
            return {
                ...state,
                data_SET_NEW_SIMULATION: null
            };
        case CLEAR_UPDATE_SIMULATION:
            return {
                ...state,
                data_SET_UPDATE_SIMULATION: null
            };
        case CLEAR_BAREMES:
            return {
                ...state,
                data_SET_BAREMES: null
            };
        case CLEAR_SIMULATE_PROMO:
            return {
                ...state,
                data_SET_SIMULATE_PROMO: null
            };
        case CLEAR_CREATE_PROMO:
            return {
                ...state,
                data_SET_CREATE_PROMO: null
            };
        case CLEAR_CHECK_PARTENAIRE:
            return {
                ...state,
                data_SET_CHECK_PARTENAIRE: null
            };
        case CLEAR_OTP_PARTENAIRE:
            return {
                ...state,
                data_SET_OTP_PARTENAIRE: null
            };
        case CLEAR_VERIFY_OTP_PARTENAIRE:
            return {
                ...state,
                data_SET_VERIFY_OTP_PARTENAIRE: null
            };
        case CLEAR_PARTENAIRE:
            return {
                ...state,
                data_SET_PARTENAIRE: null
            };
        case CLEAR_OFFRES_DETAILS:
            return {
                ...state,
                data_SET_OFFRES_DETAILS: null
            };
        case CLEAR_LOGIN_CIN:
            return {
                ...state,
                data_SET_LOGIN_CIN: null
            };
        case CLEAR_VERIFY_OTP_LOGIN_CIN:
            return {
                ...state,
                data_SET_VERIFY_OTP_LOGIN_CIN: null
            };
        case CLEAR_VERIFY_OTP_UPDATE_NUM:
            return {
                ...state,
                data_SET_VERIFY_OTP_UPDATE_NUM: null
            };
        case CLEAR_DOUBLE_VERIFY_OTP_UPDATE_NUM:
            return {
                ...state,
                data_SET_DOUBLE_VERIFY_OTP_UPDATE_NUM: null
            };
        case API_ERROR:
        case ACCESS_DENIED:
            return {
                ...state,
                isError: true
            };
        case LOCATION_CHANGE:
            if (
                action.payload.location.pathname === ROOT &&
                action.payload.action === "PUSH" &&
                action.payload.location.state
            ) {
                return {
                    ...state,
                    isOpenLogin: action.payload.location.state
                };
            }
            break;
        default:
            return state;
    }
};

export default ApiReducer;
